import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { AuthFormComponent, AuthHeaderComponent } from '../../components';
import { CredentialsDTO } from '../../application/models';
import { AppRoutes, MODAL_TOKEN, ModalProvider, PLATFORM_TOKEN, PlatformProvider, PresentModalComponent } from '@core';
import { Router } from '@angular/router';
import { LoginCommandHandler, RegisterCommandHandler } from '../../application/handlers';
import { getFirebaseAuthErrorMessage } from '../../application/utils';
import { take } from 'rxjs';
import { NgClass } from '@angular/common';

@Component({
  templateUrl: './register.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [AuthFormComponent, AuthHeaderComponent, NgClass]
})
export class RegisterPage {
  private readonly registerCommandHandler: RegisterCommandHandler = inject(RegisterCommandHandler);
  private readonly loginCommandHandler: LoginCommandHandler = inject(LoginCommandHandler);
  private readonly router: Router = inject(Router);
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);

  readonly isiOS: boolean = this.platformProvider.isiOS;

  register(event: CredentialsDTO): void {
    this.registerCommandHandler
      .register({
        email: event.email?.trim(),
        password: event.password
      })
      .pipe(take(1))
      .subscribe({
        next: () => this.loginAndRedirect(event),
        error: (err: unknown) => this.errorMessage(err)
      });
  }

  goBack(): void {
    this.router.navigate([`/${AppRoutes.AUTH}`]);
  }

  private errorMessage(err: unknown): void {
    const { header, message } = getFirebaseAuthErrorMessage(err, 'Rejestracja');
    this.modalProvider.showModal$({
      component: PresentModalComponent,
      cssClass: 'present-modal',
      componentProps: {
        header,
        message,
        btnTxt: 'Zamknij'
      }
    });
  }

  private loginAndRedirect(credentials: CredentialsDTO): void {
    this.loginCommandHandler
      .login({
        email: credentials.email,
        password: credentials.password
      })
      .pipe(take(1))
      .subscribe(() => this.router.navigate([`/${AppRoutes.DASHBOARD}`]));
  }
}
